import { Link } from 'react-router-dom';

export default function ContractorHero() {
  return (
    <header className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20contractor%20worker%20on%20a%20rooftop%20at%20golden%20hour%2C%20warm%20orange%20and%20amber%20sunlight%20casting%20long%20shadows%2C%20construction%20tools%20visible%2C%20confident%20skilled%20tradesman%20silhouette%20against%20a%20dramatic%20sky%20with%20clouds%2C%20cinematic%20wide%20angle%20photography%2C%20rich%20warm%20tones%2C%20no%20text%2C%20high%20contrast%2C%20photorealistic&width=1920&height=1080&seq=contractor-hero-bg-01&orientation=landscape"
          alt="Contractor on a job site"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/55 to-black/70" />
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 lg:px-8 text-center pt-28 pb-16">
        <div className="inline-flex items-center gap-2 bg-orange-500/20 border border-orange-500/40 text-orange-300 text-xs font-semibold px-4 py-2 rounded-full mb-8 backdrop-blur-sm">
          <span className="w-1.5 h-1.5 rounded-full bg-orange-400 animate-pulse" />
          Built for Contractors &amp; Home Service Businesses
        </div>

        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white leading-tight tracking-tight mb-6">
          AI Ads for Contractors{' '}
          <span className="text-orange-400">That Actually Get Leads</span>
        </h1>

        <p className="text-lg sm:text-xl text-stone-300 max-w-2xl mx-auto mb-4 leading-relaxed">
          No marketing degree. No agency. No guesswork.{' '}
          <strong className="text-white">AdForge builds your contractor advertising</strong> in minutes —
          Facebook ads, Google ads, Instagram ads, all done by AI.
        </p>
        <p className="text-base text-stone-400 max-w-xl mx-auto mb-10">
          Just answer a few questions about your business and let the AI handle the rest.
          Your first ad is free.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
          <Link
            to="/signup"
            className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-bold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer hover:-translate-y-0.5"
          >
            Generate Your First Ad — It&apos;s Free
          </Link>
          <a
            href="#how-it-works"
            className="px-8 py-4 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold text-base rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            See How It Works
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10">
          {[
            { value: '4.9★', label: 'Average Rating' },
            { value: '&lt; 3 min', label: 'To Your First Ad' },
            { value: 'Free', label: 'To Start' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div
                className="text-2xl font-black text-white"
                dangerouslySetInnerHTML={{ __html: stat.value }}
              />
              <div className="text-xs text-stone-400 font-medium mt-0.5">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent" />
    </header>
  );
}
